"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MoreDivider = exports.MoreDividerDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var cell_label_1 = require("./cell-label");
var badge_divider_1 = require("./badge-divider");
var sprintf_js_1 = require("sprintf-js");
var use_lang_1 = require("../../hooks/use-lang");
exports.MoreDividerDefaultProps = {};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    cursor: pointer;\n\n    &:hover {\n      .shp-badge-divider__badge {\n        border-color: ", ";\n      }\n    }\n  "], ["\n    cursor: pointer;\n\n    &:hover {\n      .shp-badge-divider__badge {\n        border-color: ", ";\n      }\n    }\n  "])), theme_1.theme.COLOR('primary'))
});
var LabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-weight: 500;\n    color: ", ";\n    text-transform: capitalize;\n  "], ["\n    font-weight: 500;\n    color: ", ";\n    text-transform: capitalize;\n  "])), theme_1.theme.COLOR('dark'))
});
// -------- Components -------->
var My = {
  Container: (0, styled_components_1.default)(badge_divider_1.BadgeDivider)(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""]))),
  Label: (0, styled_components_1.default)(cell_label_1.CellLabel)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles)
};
My.Container = (0, styled_components_1.default)(badge_divider_1.BadgeDivider)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", ";\n  &:hover {\n    ", " {\n      color: ", ";\n    }\n  }\n"], ["\n  ", ";\n  &:hover {\n    ", " {\n      color: ", ";\n    }\n  }\n"])), ContainerStyles, My.Label, theme_1.theme.COLOR('primary'));
exports.MoreDivider = react_1.default.forwardRef(function (props, ref) {
  var className = props.className,
    children = props.children,
    onClick = props.onClick,
    count = props.count;
  var t = (0, use_lang_1.useLang)();
  var label = children || (0, sprintf_js_1.sprintf)(t('+ %s More'), count);
  return react_1.default.createElement(My.Container, {
    ref: ref,
    lineVariant: "dotted",
    onClick: onClick,
    className: className
  }, react_1.default.createElement(My.Label, {
    tag: "span"
  }, label));
});
exports.MoreDivider.defaultProps = exports.MoreDividerDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;